import { render } from "./IconArrowRightReg.vue?vue&type=template&id=17337df2"
import script from "./IconArrowRightReg.vue?vue&type=script&lang=js"
export * from "./IconArrowRightReg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__